export const GET_ROLES = '@ROLE/GET_ROLES';
export const GET_ROLES_SUCCESS = '@ROLE/GET_ROLES_SUCCESS';
export const getRolesAction = () => ({
    type: GET_ROLES,
});